export const currency = {
  // Currency dropdown
  currencySearch: "Soek geldeenheid...",
  currencyFiatOnly: "Slegs fiat",
  currencyManage: "Bestuur",
  currencySelectCurrency: "Kies geldeenheid",
  currencyNoResults: "Geen geldeenhede gevind nie",
  currencyTypeFiat: "Fiat",
  currencyTypeCrypto: "Kripto",

  // Currency management modal
  currencyManageTitle: "Bestuur geldeenhede",
  currencyManageFiatTab: "Fiatgeldeenhede",
  currencyManageCryptoTab: "Kriptogeldeenhede",
  currencyManageSearchPlaceholder: "Soek in {type}...",
  currencyManageNoFiat: "Geen fiatgeldeenhede gevind nie",
  currencyManageNoCrypto: "Geen kriptogeldeenhede gevind nie",
  currencyManageClose: "Sluit",

  currencyName: "Geldeenhede",
  cryptoNames: "Kripto's",

  // Currency names
  currencyZAR: "Suid-Afrikaanse Rand",
  currencyUSD: "Amerikaanse dollar",
  currencyUSDT: "Tether USD",
  currencyCLP: "Chileense peso",
  currencyVES: "Venezolaanse bolívar",

  // Currency symbols
  currencySymbolZAR: "R",
  currencySymbolUSD: "US$",
  currencySymbolUSDT: "₮",
  currencySymbolCLP: "CL$",
  currencySymbolVES: "Bs.",

  // Conversion
  currencyConversionError: "Fout met die omskakeling van geldeenheid",
  currencyLoadingRates: "Laai wisselkoerse...",
  currencyManagementNote: "Aktiveer of deaktiveer geldeenhede om in die aftreklys te wys",
};
